<template>
  <div class="ShadeBox" @mousewheel="mousewheel">
    <div class="maskLayer"></div>
    <div class="betaToast intro-x">
      <div class="toastTitle">企业认证</div>

      <div class="formCardBaseClss">
        <p class="p1">上传营业执照</p>
        <p class="p2">请保持图片方向正确，否则系统识别不到图片信息</p>
        <div class="fromCardBox">
          <div class="fromDiv" style="margin-right: 28px">
            <input
              id="fileInput"
              ref="refFile"
              type="file"
              @change="fileLoad"
            />
            <img v-if="ID1Base64" class="IDClass" :src="ID1Base64" alt="" />

            <div v-if="!ID1Base64" class="bg-id1">
              <img src="@/assets/images/qiye.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="buttom-p">
        <span class="span1" @click="setCancel">取消</span>
        <span class="span2" @click="btnApprove">确认认证</span>
      </div>
    </div>
  </div>
</template>


<script>
import request  from '../utils/request'


export default {
  data() {
    return {
      ID1Base64: "",
      base1: "",
    };
  },

  methods: {
    // 取消实名认证
    setCancel: function () {
      this.$emit("setCancel", "Enterprise");
    },

    btnApprove: function () {
      if (this.base1 === "") {
        this.$message.error("请上传企业照片");
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "正在识别",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      request({
        url:"/api/profile/save/company",
        method:'POST',
        data:{
         company_pic: this.base1
         }
      })
        .then((res) => {
          loading.close();
          this.$emit("setCancel", "Enterprise", '刷新'); // 控制弹窗关闭
          this.$message.success("绑定/ 修改成功");
        })
        .catch((err) => {
          loading.close();
          this.$emit("setCancel", "Enterprise"); // 控制弹窗关闭
        });
    },

    //  遮罩层防滚动穿透
    mousewheel: function (e) {
      e.preventDefault();
    },

    fileLoad() {
      let selectedFile = this.$refs.refFile.files[0];
      let fileSize = 0;
      if (
        selectedFile.type != "image/jpeg" &&
        selectedFile.type != "image/png"
      ) {
        this.$message.error("请上传jpg或png格式的图片");
        return;
      }
      let suffix = selectedFile.type.split("/")[1];

      if (selectedFile) {
        fileSize = selectedFile.size / 1024;
        if (fileSize >= 1536) {
          alert("文件大小不能大于1536kb！");
          selectedFile.value = "";
          return;
        }
      }
      let reader = new FileReader();
      let name = selectedFile.name;
      let arr = name.split(".");
      reader.readAsDataURL(selectedFile);
      reader.onload = (e) => {
        let imgFile = e.target.result;
        let arr = imgFile.split(",");
        let faceBase64 = arr[1];
        let base = `data:image/${suffix};base64,`;

        this.ID1Base64 = base + faceBase64;
        this.base1 = faceBase64;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.ShadeBox {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  .maskLayer {
    position: absolute;
    left: 0;
    top: 0;
    background-color: #000000;
    opacity: 0.7;
    width: 100%;
    height: 100%;
  }
  .betaToast {
    width: 23vw;
    min-width: 21rem;
    height: 350px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 22px;
    position: fixed;
    margin: auto;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 99999;
    overflow: hidden;
    .toastTitle {
      border-bottom: 1px solid #f4f4f4;
      padding: 20px;
      font-size: 16px;
      color: #333333;
      box-sizing: border-box;
    }
  }
}

.formDataClass {
  padding: 0 20px;
  width: 100%;
  box-sizing: border-box;
  .formNameclass,
  .formIDclass {
    width: 100%;
    box-sizing: border-box;

    .p1 {
      height: 47px;
      line-height: 50px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.formCardBaseClss {
  padding: 20px;
  font-size: 14px;
  color: #333333;
  .p2 {
    color: #1890ff;
    font-size: 12px;
  }
}

.fromCardBox {
  display: flex;
  margin-top: 10px;
  .fromDiv {
    display: inline-block;
    width: 196px;
    height: 116px;
    border: 1px #607f96 dashed;
    border-radius: 7px;
    position: relative;
  }
}

#fileInput {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
}

.IDClass {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.bg-id1 {
  width: 80px;
  margin: 18px auto 0;
}

.bg-id1::after {
  content: "上传营业执照";
  color: #607f96;
  font-size: 14px;
  position: absolute;
  width: 100%;
  text-align: center;
  left: 0;
  padding-top: 7px;
}

.buttom-p {
  height: 80px;
  width: 100%;
  border-top: 1px solid #f4f4f4;

  text-align: right;
  padding: 20px;
  box-sizing: border-box;

  span {
    display: inline-block;
    padding: 10px 25px;
    margin-left: 4px;
    vertical-align: middle;
    box-sizing: border-box;
    border-radius: 6px;
  }
  .span1 {
    border: 1px solid #e2e8f0;
  }

  .span2 {
    color: #fff;
    background: #1890ff;
  }

  .span2:active {
    background: #2d9aff;
  }

  .span1:active {
    background: #e9e9e9;
  }
}
</style>